import axios from "axios";
import axiosInterceptor from "./axios.interceptor";

import qs from "qs";

const setBaseUrl = () => {
  const host = window.location.hostname;
  let hostMapping;
  try {
    hostMapping = JSON.parse(import.meta.env.VUE_APP_HOST_MAPPING || "{}");
  } catch (e) {
    hostMapping = {};
  }
  const froogalCoreUrl =
    hostMapping[host] || import.meta.env.VUE_APP_FROOGAL_CORE_URL || "";
  return froogalCoreUrl.replace(/\/$/g, "") + "/";
};
export const baseUrl = setBaseUrl();
export const actionUrl = (import.meta.env.VUE_APP_FROOGAL_ACTION_URL || "").replace(/\/$/g, "") + "/";
export const RBACUrl = (import.meta.env.VUE_APP_RBAC_URL || import.meta.env.VUE_APP_FROOGAL_CORE_URL).replace(/\/$/g, "") + "/";
export const feedbackUrl = (import.meta.env.VUE_APP_FEEDBACK_URL || import.meta.env.VUE_APP_FROOGAL_CORE_URL).replace(/\/$/g, "") + "/";

const oauthServer = import.meta.env.VUE_APP_OAUTH_SERVER_URL;

const latestTokens = {};
const latestTokensMap = new Map();
const latestFactory = function (method, axiosInstance = client) {
  return function (url, config, symbol = null) {
    const key = Math.round(Math.random() * 1000000);
    if (symbol) {
      latestTokensMap.set(symbol, key);
    } else {
      latestTokens[url] = key;
    }
    const getTokenKey = () => symbol ? latestTokensMap.get(symbol) : latestTokens[url];
    // TODO: cancel request
    return new Promise(function (resolve, reject) {
      axiosInstance[method](url, config)
        .then((result) => {
          if (key === getTokenKey()) {
            resolve(result);
          }
        })
        .catch((e) => {
          if (key === getTokenKey()) {
            reject(e);
          }
        });
    });
  };
}

export const client = axios.create({
  baseURL: baseUrl,
  paramsSerializer: function (params) {
    const a = qs.stringify(params, { arrayFormat: "brackets" });
    return a;
  },
});
client.getLatest = latestFactory('get');
client.postLatest = latestFactory('post');

export const RBACclient = axios.create({
  baseURL: RBACUrl,
  paramsSerializer: function (params) {
    const a = qs.stringify(params, { arrayFormat: 'brackets' });
    return a;
  },
});

export const feedbackClient = axios.create({
  baseURL: feedbackUrl,
  paramsSerializer: function (params) {
    const a = qs.stringify(params, { arrayFormat: 'brackets' });
    return a;
  },
});
feedbackClient.getLatest = latestFactory('get', feedbackClient);
feedbackClient.postLatest = latestFactory('post', feedbackClient);

axiosInterceptor.setupInterceptors(client);
axiosInterceptor.setupInterceptors(RBACclient);
axiosInterceptor.setupInterceptors(feedbackClient);

export const urls = {
  logout: `${oauthServer}/api/logout`,
  loginAs: `${oauthServer}/login-as`,
  generatePersonalAccessToken: `${oauthServer}/oauth/personal-access-tokens`,
  merchants: "business/api/merchants",
  permissions: "business/api/permissions",
  creditsData: "business/dashboard-data/get-credits",
  getMerchantUsageCreditsData:
    "business/dashboard-data/get-merchant-usage-credits-data",
  giftListUrl: "gifting/api/gifting-list",
  getReferralProgramsUrl: "referral/brand-programs",
  getTimePickerDataUrl:"business/timezone",
  getMerchantUsageCreditsData: "business/dashboard-data/get-merchant-usage-credits-data",
  getHistoryUrl: 'business/api/config/objects/audit-logs',
};

export function setToken(token) {
  client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  RBACclient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  feedbackClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function setBrandId(brand) {
  client.defaults.headers.common["X-Brand-ID"] = brand.id;
  RBACclient.defaults.headers.common["X-Brand-ID"] = brand.id;
  feedbackClient.defaults.headers.common["X-Brand-ID"] = brand.id;
  if( brand.flags?.timezonePicker ) {
    client.defaults.headers.common["X-Timezone"] = localStorage.getItem(`timeZone-${brand.id}`);
    RBACclient.defaults.headers.common["X-Timezone"] = localStorage.getItem(`timeZone-${brand.id}`);
    feedbackClient.defaults.headers.common["X-Timezone"] = localStorage.getItem(`timeZone-${brand.id}`);
  }
}
export function setTimezone(timezone) {
  client.defaults.headers.common["X-Timezone"] = timezone;
  RBACclient.defaults.headers.common["X-Timezone"] = timezone;
  feedbackClient.defaults.headers.common["X-Timezone"] = timezone;
}

client.defaults.headers.common["X-Dashboard-Version"] = "2";
RBACclient.defaults.headers.common["X-Dashboard-Version"] = "2";
feedbackClient.defaults.headers.common["X-Dashboard-Version"] = "2";
